export default __webpack_public_path__ + "static/media/axion-today-dark.f7c7e1da.png";